import { createContext } from 'react'

type AppBarContextValue = {
  mode: 'sticky' | 'fixed' | undefined
  stickyTriggerRef: React.RefObject<HTMLDivElement>
}

export const AppBarContext = createContext<AppBarContextValue>({
  mode: undefined,
  stickyTriggerRef: { current: null },
})
